import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrderingChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 2,
		y: 2,
		width: 8,
		height: 8,
		rx: 4,
		fill: "#118AB2"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 2,
		y: 2,
		width: 8,
		height: 8,
		rx: 4,
		stroke: "white",
		strokeWidth: 4
	})]
});
export default SvgOrderingChecked;
